import { Component, OnInit, OnDestroy } from '@angular/core';
import { PhBhpFeaturePackageSopobservationService } from '../ph-bhp-feature-package-sopobservation.service';
import { Department } from '../Models/Department';
import { ProfessionalSubCategory } from '../../models/professional-sub-category';
import { Ward } from '../Models/Ward';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { forkJoin, Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { Observable } from 'rxjs/internal/Observable';
import { TranslationKeys } from 'ph-bhp-localization';
import { catchError } from 'rxjs/operators';
import { CatalogMasterService } from '../../services/catalog-master.service';
import { ProfessionalCategory } from 'src/app/models/professional-category';
import { ProfessionalSubCategoryDTO } from 'src/app/models/professional-sub-category-dto';
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { ThemeService } from '@progress/kendo-angular-charts/common/theme.service';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-ph-bhp-new-sopobserve',
  templateUrl: './ph-bhp-new-sopobserve.component.html',
  styleUrls: ['./ph-bhp-new-sopobserve.component.css']
})
export class PhBhpNewSopobserveComponent implements OnInit, OnDestroy {
  /**
   * Role id of the current user
   */
  userRoleId: number;
  subscription: Subscription;
  allDepartments: Array<Department> = [];
  allProfessionalCategories: Array<ProfessionalCategory> = []
  allSubCategories: Array<ProfessionalSubCategoryDTO> = [];
  allSubCategoriesSelected: Array<ProfessionalSubCategoryDTO> = [];
  allWards: Array<Ward> = []
  showProfessionalSubcategory: boolean;
  wardWarningMessage: boolean = false;
  connectionWarningMessage: boolean = false;
  showMessageLaptop: boolean = false;
  showMessageApple: boolean = false;
  showMessageAndroid: boolean = false;
  connectionMessage: string = "";
  showTask: boolean = false
  emitData: any = {
    key: "",
    val: ""
  }
  formdata: UntypedFormGroup;
  private wasSubmitted: Boolean;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  userSubjectSubscription: Subscription;

  constructor(
    private service: PhBhpFeaturePackageSopobservationService,
    private layoutService: PHBHPLayoutPackageService,
    public appConfig: AppConfig,
    private catalogMasterService: CatalogMasterService,
    public translate: TranslateService,
    private router: Router
  ) { }

  onWardIDChange(event: Ward) {
    if (event.wardID) {
      this.wardWarningMessage = false;
      var dep = this.allDepartments.find((res) => res.departmentID == event.departmentID)
      this.formdata.patchValue({ department: dep });
      this.formdata.patchValue({ wardName: event.wardName });
      this.formdata.patchValue({ ward: event });
    } else {
      this.wardWarningMessage = true;
    }
  }

  ngOnInit() {

    if (this.appConfig.userData && this.appConfig.userData.roleName) {
      this.userRoleId = this.appConfig.userData.roleName.roleId;
    }

    this.userSubjectSubscription = this.appConfig.userSubject.asObservable().subscribe((res) => {
      this.userRoleId = this.appConfig.userData.roleName.roleId;
    })

    if (this.layoutService.institutionID) {
      this.getWardsandDepartmentsAndCategoriesbyInstitutionId();
    }

    this.formdata = new UntypedFormGroup({
      // TODO this is now readonly, so could remove form altogether
      department: new UntypedFormControl("", Validators.compose([
        Validators.required
      ])),
      ward: new UntypedFormControl("", Validators.compose([
        Validators.required
      ])),
      category: new UntypedFormControl("", Validators.compose([
        Validators.required
      ])),
      subCategory: new UntypedFormControl(""),
      wardName: new UntypedFormControl(""),
      categoryName: new UntypedFormControl(""),
      subCategoryName: new UntypedFormControl(""),
    })

    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.showTask = false;
      this.allWards = [];
      this.allDepartments = [];
      this.getWardsandDepartmentsAndCategoriesbyInstitutionId();
    });

    this.connectionWarningMessage = true;
    this.layoutService.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.setConnectionMessage();
    });

    this.setConnectionMessage();
  }

  setConnectionMessage() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) {
      this.showMessageLaptop = true;
      this.showMessageApple = true;
      this.showMessageAndroid = true;
    } else {
      var isApple = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      this.showMessageApple = isApple;
      this.showMessageAndroid = !isApple;
    }
  }


  ngOnDestroy() {
    if (this.userSubjectSubscription)
      this.userSubjectSubscription.unsubscribe();

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getWardsandDepartmentsAndCategoriesbyInstitutionId() {

    this.layoutService.showLoader = true;

    const configDetails: Observable<any> = this.service.getConfigDetails(this.layoutService.institutionID);
    const departaments: Observable<any> = this.service.getWardsDepartmentsbyInstitutionId(this.layoutService.institutionID);
    const professionaLCategories: Observable<ProfessionalCategory[]> = this.catalogMasterService.getProfessionalCategories();
    const professionalSubCategories: Observable<ProfessionalSubCategoryDTO[]> = this.catalogMasterService.getProfessionalSubCategoriesByCountry(this.layoutService.institutionCountryId)

    forkJoin([configDetails, departaments, professionaLCategories, professionalSubCategories]).subscribe(([configDetails, departamentsAndWardsRes, professionaLCategoriesRes, professionalSubCategoriesRes]) => {

      this.showProfessionalSubcategory = configDetails.enableProfessionalSubCategory;

      if (departamentsAndWardsRes && departamentsAndWardsRes['wardsDetails']) {
        this.allWards = departamentsAndWardsRes['wardsDetails'];
        this.allWards = this.allWards.filter(ward => ward.departmentID && ward.isActive && !ward.isDeleted);
      };
      if (departamentsAndWardsRes && departamentsAndWardsRes['departments']) {
        this.allDepartments = departamentsAndWardsRes['departments'];
      };
      if (this.allWards.length === 0) {
        this.wardWarningMessage = true;
      } else {
        this.wardWarningMessage = false;
        this.formdata.patchValue({
          department: this.allDepartments.find(dep => dep.departmentID === this.allWards[0].departmentID),
          ward: this.allWards[0],
          wardName: this.allWards[0].wardName
        });
      }

      this.allProfessionalCategories = professionaLCategoriesRes;
      this.formdata.patchValue({
        category: this.allProfessionalCategories[0],
        categoryName: this.allProfessionalCategories[0].categoryName,
      });

      if (this.showProfessionalSubcategory) {
        // this.allSubCategories = professionalSubCategoriesRes.filter(subcategory=> {
        //   if(this.userRoleId == 1) return true;

        //   if(!ProfessionalSubCategoryDTO.isEnabledForNewObservations(subcategory)){
        //     return false;
        //   }else if(!subcategory.professionalSubCategoryCountryConfiguration || subcategory.professionalSubCategoryCountryConfiguration.visibilityType === 'all'){
        //     return true;
        //   }else if(subcategory.professionalSubCategoryCountryConfiguration.visibilityType == 'institutions'){
        //     return subcategory.professionalSubCategoryCountryConfiguration?.professionalSubCategoriesVisibility.some(v=> v.institutionId == this.layoutService.institutionID);
        //   }else{
        //     // visibilityType == 'country'
        //     return subcategory.professionalSubCategoryCountryConfiguration.countryID == this.layoutService.institutionCountryId;
        //   }

        // });
        this.allSubCategories = professionalSubCategoriesRes.filter(this.filterVisibility);
        this.allSubCategoriesSelected = this.allSubCategories.filter(sc => sc.categoryID === this.allProfessionalCategories[0].categoryID);
        if (this.allSubCategoriesSelected && this.allSubCategoriesSelected.length > 0) {
          this.formdata.patchValue({
            subCategory: this.allSubCategoriesSelected[0],
            subCategoryName: this.layoutService.getSubCategoryName(this.allSubCategoriesSelected[0])
          });
        } else {
          this.formdata.patchValue({
            subCategory: '',
            subCategoryName: ''
          });
        }
      }

      this.layoutService.showLoader = false;

    },
      err => {
        this.wardWarningMessage = true;
        this.layoutService.showLoader = false;
      });

  }



  onProfessionalCategoryChange(value: ProfessionalCategory) {
    this.formdata.patchValue({
      category: value,
      categoryName: value.categoryName
    });

    this.allSubCategoriesSelected = this.allSubCategories.filter(sc => sc.categoryID === value.categoryID);
    if (this.allSubCategoriesSelected && this.allSubCategoriesSelected.length > 0) {
      this.formdata.patchValue({
        subCategory: this.allSubCategoriesSelected[0],
        subCategoryName: this.layoutService.getSubCategoryName(this.allSubCategoriesSelected[0])
      });
    } else {
      this.formdata.patchValue({
        subCategory: '',
        subCategoryName: ''
      });
    }

  }

  onProfessionalSubCategoryChange(value) {

    const subCategoryName = this.layoutService.getSubCategoryName(value);

    this.formdata.patchValue({
      subCategory: value,
      subCategoryName: subCategoryName
    });
  }

  onClickSubmit(value) {
    // if a user has not touched a field, this will show all errors, if the value is invalid.
    this.wasSubmitted = true;

    if (this.formdata.invalid) {
      return true;
    }
    this.showTask = true;
  }

  selectSopobserveChildData(event) {
    switch (event.key) {
      case 'back': this.showTask = false; break;
      //case 'saveSuccess': this.formdata.reset(); this.preSelect(); this.preSelectDepSubCat(); this.showTask = false; break;
      case 'saveSuccess': 
        this.showTask = false; 
        this.router.navigate(["/sopObserve/observeProtocol"]);
        break;
      case 'startSopObserve': /**/;
    }
  }

  async getConfigDetails(institutionid) {
    this.service.getConfigDetails(institutionid).subscribe((res) => {
      this.showProfessionalSubcategory = res.enableProfessionalSubCategory;
    });
  }

  /**
   * Whether a field should be shown as invalid.
   * @param fieldName
   */
  // TODO extract form helper for use in other pages
  showFieldInvalid(fieldName: string) {
    const field = this.formdata.get(fieldName);

    // no errors
    if (!field.errors) {
      return false;
    }

    // show errors, if user entered field
    return field.touched ||
      // if user changed value
      field.dirty ||
      // or if user tried to submit field
      this.wasSubmitted;
  }

  filterVisibility = (subCategory: ProfessionalSubCategoryDTO) => {
    switch (this.userRoleId) {
      case 2:
        if (!ProfessionalSubCategoryDTO.isEnabledForNewObservations(subCategory)) {
          return false;
        } else if (subCategory.professionalSubCategoryCountryConfiguration && subCategory.professionalSubCategoryCountryConfiguration.visibilityType != 'all') {
          // show same country subcategory for CA, no matter visibilityType
          return subCategory.professionalSubCategoryCountryConfiguration.countryID == (+this.appConfig.userData.country);
        }
        return true; // all global subcategories

      case 3:
      case 4:
      case 5:
        if (!subCategory.professionalSubCategoryCountryConfiguration) {
          return true;
        } else if (subCategory.professionalSubCategoryCountryConfiguration.professionalSubcategoriesEnabilityByIA && subCategory.professionalSubCategoryCountryConfiguration.professionalSubcategoriesEnabilityByIA.length > 0) {
          let enability = subCategory.professionalSubCategoryCountryConfiguration.professionalSubcategoriesEnabilityByIA.find(e => e.institutionId == this.layoutService.institutionID);
          return enability ? enability.isEnabledForNewObservations : ProfessionalSubCategoryDTO.isEnabledForNewObservations(subCategory);
        } else if (!ProfessionalSubCategoryDTO.isEnabledForNewObservations(subCategory)) {
          return false;
        } else if (subCategory.professionalSubCategoryCountryConfiguration.visibilityType === 'all') {
          return true;
        } else if (subCategory.professionalSubCategoryCountryConfiguration && subCategory.professionalSubCategoryCountryConfiguration.visibilityType == 'institutions') {
          return subCategory.professionalSubCategoryCountryConfiguration?.professionalSubCategoriesVisibility.some(v => v.institutionId == this.layoutService.institutionID);
        } else if (subCategory.professionalSubCategoryCountryConfiguration && subCategory.professionalSubCategoryCountryConfiguration.visibilityType == 'country') {
          return subCategory.professionalSubCategoryCountryConfiguration.countryID == (+this.appConfig.userData.country);
        }
        return false;
    }
  }

  onClickWardHandler(event: Event) {
    this.layoutService.showLoader = true;
    this.service.getWardsDepartmentsbyInstitutionId(this.layoutService.institutionID).subscribe((departamentsAndWardsRes) => {
      if (departamentsAndWardsRes && departamentsAndWardsRes['wardsDetails']) {
        this.allWards = departamentsAndWardsRes['wardsDetails'];
        this.allWards = this.allWards.filter(ward => ward.departmentID && ward.isActive && !ward.isDeleted);
      };

      if (departamentsAndWardsRes && departamentsAndWardsRes['departments']) {
        this.allDepartments = departamentsAndWardsRes['departments'];
      };

      this.wardWarningMessage = this.allWards.length === 0;
      if (!this.wardWarningMessage && !this.allWards.find((ward) => ward.wardID == this.formdata.get('ward').value.wardID)) {
        this.formdata.patchValue({
          department: this.allDepartments.find(dep => dep.departmentID === this.allWards[0].departmentID),
          ward: this.allWards[0],
          wardName: this.allWards[0].wardName
        });
      }
    }, (error) => { }, () => { this.layoutService.showLoader = false });
  }

  getDepartmentTypeName(ward: any) {
    return ward.departmentTypeID === 1 ? '' : `(${ this.layoutService.translateText(ward.departmentTypeName) })`;
  }
}
